// extracted by mini-css-extract-plugin
export default {"cartChip":"bHTwSq8pQo1RjkHK_ZAg"};